<template>
  <div class="skills">
    <div class="container-skill">
      <div class="content-skill">
        <section class="modelisation">
          <img src="@/assets/ribbon-design.svg" alt="Modelisation" class="skill-icon" />
          <h4>Modélisation & maquettage</h4>
          <p>Analyse technique et visuelle de la solution</p>
          <article>
            <h5 class="title-skill">Modélisation</h5>
            <p>MCD, MLD, Diagrammes UML et de séquence</p>
          </article>
          <article>
            <h5 class="title-skill">Logiciels de modélisation</h5>
            <ul>
              <li>Workbench</li>
              <li>Draw.io</li>
            </ul>
          </article>
          <article>
            <h5 class="title-skill">Logiciels de design</h5>
            <ul>
              <li>Illustrator</li>
              <li>InDesign</li>
              <li>Photoshop</li>
              <li>Adobe XD</li>
              <li>Figma, Balsamiq</li>
            </ul>
          </article>
        </section>
        <section class="dev">
          <img src="@/assets/coding.svg" alt="Development" class="skill-icon" />
          <h4>Développement front & back</h4>
          <p>Applications web, logiciels, API et bases de données</p>
          <article>
            <h5 class="title-skill">Langages</h5>
            <ul>
              <li>JavaScript, Typescript, C#, Java SE, JEE, Python, PHP, HTML, CSS</li>
            </ul>
          </article>
          <article>
            <h5 class="title-skill">Frameworks et librairies</h5>
            <ul>
              <li>Angular</li>
              <li>VueJS</li>
              <li>React, React Native</li>
              <li>Blazor</li>
            </ul>
          </article>
          <article>
            <h5 class="title-skill">Bases de données</h5>
            <ul>
              <li>SQL Server, MySQL, MariaDB, Oracle</li>
              <li>MongoDB</li>
            </ul>
          </article>
          <article>
            <h5 class="title-skill">Autres</h5>
            <ul>
              <li>Unity</li>
              <li>Blender</li>
              <li>Arduino</li>
            </ul>
          </article>
        </section>
      </div>
      <div class="social">
        <a target="_blank" href="https://gitlab.com/thweb"><i class="icons8-gitlab"></i></a>
        <a :href="pdfLink" download="etatibouet_cv.pdf"> <i class="icons8-download"></i></a>
        <a target="_blank" href="https://www.linkedin.com/in/anaïs-tatibouet-developpeur/"
          ><i class="icons8-linkedin"></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skills',
  data() {
    return {
      pdfLink: '/etatibouet_cv.pdf'
    };
  }
};
</script>

<style lang="scss" scoped>
.skills {
  background-color: var(--grey);
  padding: 30px;
  height: 1000px;

  .container-skill {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    position: relative;
    top: -110px;

    .modelisation,
    .dev {
      background-color: var(--white);
      padding: 20px;

      img {
        width: 60px;
      }
      h4 {
        text-transform: uppercase;
        color: var(--black);
        margin-bottom: 0;
      }
      p {
        font-size: 14px;
      }

      article {
        margin-top: 30px;

        .title-skill {
          color: var(--blue);
          text-transform: uppercase;
          margin: 0;
        }

        p {
          margin: 0;
        }

        li {
          font-size: 14px;
        }
      }
    }

    .modelisation {
      border-top-right-radius: 3px;
      border-top-left-radius: 3px;
      border-bottom: 1px solid var(--grey);
    }

    .social {
      display: flex;
      justify-content: space-between;
      background-color: var(--darkgrey);
      padding: 10px 20px;
      border-bottom-right-radius: 3px;
      border-bottom-left-radius: 3px;

      i {
        color: white;
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .skills {
    height: 650px;
    .container-skill {
      .content-skill {
        display: flex;
        flex-flow: row;

        h4 {
          font-size: 25px;
        }

        .modelisation,
        .dev {
          padding: 50px 0;
          width: 50%;
          .title-skill {
            font-size: 20px;
          }
          p,
          li {
            font-size: 20px;
          }
        }

        .modelisation {
          border-bottom: none;
          border-top-right-radius: 0;
          border-right: 1px solid var(--grey);
        }
        .dev {
          border-top-right-radius: 3px;
        }
      }
      .social {
        a {
          i {
            font-size: 30px;
          }

          i:hover {
            color: var(--orange);
          }
        }
      }
    }
  }
}
</style>
